export const INFO_DOC_DATEINAMEN_NAME = 'Info_BPlan-Zusatzdokumente_WUP.pdf';
export const INFO_DOC_DATEINAMEN_URL =
	'https://wunda-geoportal-docs.cismet.de/bplaene_dokumente/Info_BPlan-Zusatzdokumente_WUP.pdf';
